import http from 'plugins/axios';

export default {
    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
    getUserMiningRateList(data) {
        return http.get({
            url: '/admin/mining/rate/list',
            data: data
        });
    },
    addUserMiningRate(data) {
        return http.post({
            url: '/admin/mining/rate/add',
            data: data,
            dataType: 'form'
        });
    },
    updateUserMiningRate(data) {
        return http.post({
            url: '/admin/mining/rate/update',
            data: data,
            dataType: 'form'
        });
    },
    getUserMiningList(data) {
        return http.get({
            url: '/admin/mining/award/mininglist',
            data: data
        });
    },
    getUserAwardlist(data) {
        return http.get({
            url: '/admin/mining/award/awardlist',
            data: data
        });
    },
    getUserMiningAward(data) {
        return http.get({
            url: '/admin/mining/award/award',
            data: data
        });
    },
    adminCalculateMiningAward(data) {
        return http.post({
            url: '/admin/mining/award/calculateAward',
            data: data,
            dataType: 'form'
        });
    },
    adminAwardTransfer(data) {
        return http.post({
            url: '/admin/mining/award/awardTransfer',
            data: data,
            dataType: 'form'
        });
    },
    getCurrentMiningList(data) {
        return http.get({
            url: '/admin/current/mining/list',
            data: data
        });
    },
    updateCurrentAccount(data) {
        return http.post({
            url: '/admin/current/mining/updateAccount',
            data: data,
            dataType: 'form'
        });
    },
    getUserMiningRecord(data) {
        return http.get({
            url: '/admin/mining/award/miningRecord',
            data: data
        });
    },
    deleteAward(data) {
        return http.post({
            url: '/admin/mining/award/deleteAward',
            data: data,
            dataType: 'form'
        });
    },
    unLockUserMining(data) {
        return http.post({
            url: '/admin/mining/award/unLockUserMining',
            data: data,
            dataType: 'form'
        });
    },
    calculateMiningAward(data) {
        return http.post({
            url: '/admin/mining/award/calculateAwardByJson',
            data: data,
            dataType: 'form'
        });
    }

};
